<template>
  <img
    class="block lazyload"
    :data-src="src"
    :data-srcset="srcset"
    data-sizes="auto"
    :alt="alt"
  >
</template>

<script>
/*
* Responsive Image Vue component
* ---
* Example usage:
*
* <responsive-image
*   :src="product.media[0].src"
*   :base-size="500"
*   :alt="product.media[0].alt || product.title"
*   class="block">
* </responsive-image>
*/

export default {
  props: {
    src: {
      type: String,
      required: true
    },

    alt: {
      type: String,
      default: ''
    },

    baseSize: {
      type: Number,
      default: null
    }
  },

  data () {
    return {
      srcsetSizes: [
        352,
        832,
        1200,
        1920
      ]
    }
  },

  computed: {
    srcset () {
      const sizes = this.srcsetSizes.map(size => `${this.$options.filters.imageSize(this.src, `${size}x`)} ${size}w`)
      return sizes.join(', ')
    }
  },

  created () {
    if (this.baseSize) {
      this.srcsetSizes = [
        this.baseSize * 0.5,
        this.baseSize * 0.75,
        this.baseSize,
        this.baseSize * 1.5,
        this.baseSize * 2
      ]

      this.srcsetSizes = this.srcsetSizes.map(sizes => {
        return parseInt(sizes)
      })
    }
  },

  methods: {

  }
}
</script>
